import { useState } from "react";
import classNames from "classnames";
import { Dropdown, Spinner } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  formatToIndianNumber,
  getFullRoleName,
  toInitials,
  useIsMobile,
} from "../../../utilities";
import { Popover } from "@mui/material";
import {
  Image,
  Icon,
  MediaGroup,
  MediaText,
  Media,
  LinkList,
  LinkListItem,
  CustomDropdownToggle,
  CustomDropdownMenu,
  Schedule,
} from "../../../components";
import { TiDelete } from "react-icons/ti";
import { FaCheckCircle } from "react-icons/fa";
import ToggleSidebar from "../Toggle/Sidebar";
import LogoutPage from "./Logout";
import { useLayout, useLayoutUpdate } from "./../LayoutProvider";
import { useEffect } from "react";
import Headermenu from "./Headermenu";
import ProfileDialog from "../../../pages/Users/ProfileModal"; // Import the new dialog component
import { FaBell } from "react-icons/fa";
import {
  getNotificationApi,
  gettActionNotification,
} from "../../../services/DashboardService";
import { format } from "date-fns";
function QuickNav({ className, ...props }) {
  const compClass = classNames({
    "nk-quick-nav": true,
    [className]: className,
  });
  return <ul className={compClass}>{props.children}</ul>;
}

function QuickNavItem({ className, ...props }) {
  const compClass = classNames({
    "d-inline-flex": true,
    [className]: className,
  });
  return <li className={compClass}>{props.children}</li>;
}

function Header({ user, userRole, allowEmail, allowWhatsApp }) {
  const isMobile = useIsMobile();
  const [show, setShow] = useState(false);
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const layout = useLayout();
  const layoutUpdate = useLayoutUpdate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [notification, setNotification] = useState([]);
  const handleOpenNotification = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseNotification = () => {
    setAnchorEl(null);
  };

  const isOpenNotification = Boolean(anchorEl);
  const compClass = classNames({
    "nk-header nk-header-fixed": true,
    [`is-${layout.headerVariant}`]: layout.headerVariant,
  });

  const handleClick = () => {
    setShow(false);
  };

  const handleProfileClick = () => {
    setShow(false);
    setProfileDialogOpen(true);
  };

  const getNotification = () => {
    setNotificationLoading(true);
    getNotificationApi()
      .then((res) => {
        setNotification(res?.data?.data || []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setNotificationLoading(false));
  };
  const handleNotificationAction = (id, type) => {
    setNotificationLoading(true);
    gettActionNotification(id, { action: type })
      .then((res) => {
        getNotification();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setNotificationLoading(false));
  };
  useEffect(() => {
    if (userRole == "admin") {
      getNotification();
    }
  }, []);
  return (
    <>
      <div className={compClass}>
        <div className="container-fluid">
          <div className="nk-header-wrap">
            <div className="nk-header-logo me-2">
              <ToggleSidebar variant="zoom" icon="menu" />
            </div>
            {layout.headerActive && (
              <div
                className="navbar-overlay"
                onClick={layoutUpdate.headerMobile}
              ></div>
            )}
            {userRole !== "admin" && (
              <span
                className="px-2 py-1 rounded-3 shadow-sm border border-light"
                style={{
                  backgroundColor: "#fff",
                  fontSize: "0.78rem",
                }}
              >
                {user?.service_center_name}
              </span>
            )}
            <div className="nk-header-tools ms-auto">
              <QuickNav>
                <QuickNavItem>
                  {userRole == "admin" && (
                    <div className="position-relative me-3">
                      <button
                        type="button"
                        className="btn btn-transparent rounded-3 shadow-sm border border-light"
                        style={{ padding: "0.4rem" }}
                        onClick={handleOpenNotification}
                      >
                        <FaBell className="text-secondary fs-6" />
                      </button>
                      {notification?.length > 0 && (
                        <span
                          className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger shadow-sm"
                          style={{ fontSize: "0.6rem" }}
                        >
                          {notification?.length}
                        </span>
                      )}
                    </div>
                  )}
                </QuickNavItem>

                <Dropdown
                  as={QuickNavItem}
                  show={show}
                  onToggle={(isOpen) => setShow(isOpen)}
                >
                  <Dropdown.Toggle bsPrefix as={CustomDropdownToggle}>
                    <div className="d-inline-flex">
                      <MediaGroup>
                        <Media size="md" shape="circle" variant="dark-soft">
                          {user?.profile_photo ? (
                            <Image
                              src={`${process.env.REACT_APP_BASE_URL}${user?.profile_photo}`}
                              staticImage
                              alt="user"
                            />
                          ) : (
                            <span className="fw-medium">
                              {toInitials(user?.name)}
                            </span>
                          )}
                        </Media>
                        {!isMobile && (
                          <MediaText>
                            <div className="lead-text text-uppercase">
                              {user?.name}
                            </div>
                            <span className="sub-text text-mute">
                              {user?.email}
                            </span>
                          </MediaText>
                        )}
                      </MediaGroup>
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="dropdown-menu-md"
                    as={CustomDropdownMenu}
                  >
                    <div className="dropdown-content dropdown-content-x-md py-1 border-bottom border-light">
                      <MediaGroup>
                        <Media size="lg" shape="circle" variant="dark-soft">
                          {user?.profile_photo ? (
                            <Image
                              src={`${process.env.REACT_APP_BASE_URL}${user?.profile_photo}`}
                              staticImage
                              alt="user"
                            />
                          ) : (
                            <span className="fw-medium">
                              {toInitials(user?.name)}
                            </span>
                          )}
                        </Media>

                        <MediaText>
                          <div className="lead-text text-uppercase">
                            {user?.name}
                          </div>
                          <span className="sub-text text-uppercase">
                            {user?.is_superuser ? "Admin" : "User"}
                          </span>
                        </MediaText>
                      </MediaGroup>
                    </div>
                    <div
                      className="dropdown-content dropdown-content-x-lg py-1 border-bottom border-light"
                      onClick={handleClick}
                    >
                      <LinkList>
                        <LinkListItem onClick={handleProfileClick}>
                          <Icon name="user"></Icon>
                          <span>My Profile</span>
                        </LinkListItem>
                        <LinkListItem to="/account-settings">
                          <Icon name="setting-alt"></Icon>
                          <span>Account Settings</span>
                        </LinkListItem>
                      </LinkList>
                    </div>
                    <div
                      className="dropdown-content dropdown-content-x-lg py-0"
                      onClick={handleClick}
                    >
                      <LogoutPage />
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </QuickNav>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Dialog */}
      <ProfileDialog
        open={profileDialogOpen}
        onClose={() => setProfileDialogOpen(false)}
      />

      <Popover
        className="scroll-container"
        open={isOpenNotification}
        anchorEl={anchorEl}
        onClose={handleCloseNotification}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            p: 1,
            mt: 1,
            boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
            borderRadius: "8px",
            width: {
              xs: "90vw",
            },
            minWidth: { sm: "300px" },
            maxWidth: { sm: "500px" },
          },
        }}
      >
        <div
          className="scroll-container"
          style={{ overflowY: "scroll", maxHeight: "280px" }}
        >
          {notificationLoading ? (
            <div className="text-center my-3">
              <Spinner animation="border" size="sm" />
            </div>
          ) : notification && notification?.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-sm table-borderless mb-0 align-middle fs-6">
                <thead className="custom-thead">
                  <tr>
                    <th>Date</th>
                    <th>Category</th>
                    <th>Amount</th>
                    {/* <th>Service center</th> */}
                    <th>Created</th>
                    <th className="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {notification.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {item?.date
                          ? format(new Date(item?.date), "dd MMM yyyy")
                          : "-"}
                      </td>
                      <td>{item?.category}</td>

                      <td className="fw-semibold">
                        ₹{formatToIndianNumber(item?.amount)}
                      </td>
                      {/* <td>{item?.service_center_name || "-"}</td> */}
                      <td>{item?.created_by_name || "-"}</td>
                      <td className="text-end">
                        <div className="d-flex gap-2 justify-content-end">
                          <button
                            className="btn btn-outline-success btn-sm rounded-2 d-flex align-items-center justify-content-center"
                            onClick={() =>
                              handleNotificationAction(
                                item?.id || "",
                                "approve"
                              )
                            }
                            style={{
                              width: "25px",
                              height: "25px",
                              padding: 0,
                            }}
                          >
                            <FaCheckCircle size={14} />
                          </button>

                          <button
                            className="btn btn-outline-danger btn-sm rounded-2 d-flex align-items-center justify-content-center"
                            onClick={() =>
                              handleNotificationAction(item?.id || "", "reject")
                            }
                            style={{
                              width: "25px",
                              height: "25px",
                              padding: 0,
                            }}
                          >
                            <TiDelete size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center my-3">No data found</div>
          )}
        </div>
      </Popover>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth.user || null,
  userRole: state.auth.user?.is_superuser ? "admin" : "user" || "user",
  allowEmail: state.auth.user?.is_allow_email_notification || false,
  allowWhatsApp: state.auth.user?.is_allow_whatsapp_notification || false,
});

export default connect(mapStateToProps)(Header);
